import PropTypes from 'prop-types';
import * as Styled from './Style';
/**
 * Компонент отображения точек рейса
 */
export const Points = ({
  isExpanded,
  topPoints,
  bottomPoints,
  transferPoints,
  hiddenPoints,
  hiddenPointsCount,
  isExpandButtonShown,
  isCollapseButtonShown,
  onToggle,
  isToggleHidden,
  isPreviewDetails
}) => {
  const isToggleShown = (isExpandButtonShown || isCollapseButtonShown) && !isToggleHidden;
  return /*#__PURE__*/React.createElement(Styled.WrapperPoints, {
    isPreviewDetails: isPreviewDetails
  }, /*#__PURE__*/React.createElement("span", {
    className: "mobile-ticket__segment-divider"
  }), topPoints, !isExpanded && transferPoints, hiddenPoints, bottomPoints, isToggleShown && /*#__PURE__*/React.createElement(Styled.Toggle, {
    onClick: onToggle
  }, isExpandButtonShown ? I18n.t('pages.search.trip.points.common_count', {
    count: hiddenPointsCount
  }) : I18n.t('pages.search.trip.collapse_list')));
};
// eslint-disable-next-line no-multi-assign
Points.propTypes = {
  topPoints: PropTypes.array.isRequired,
  hiddenPoints: PropTypes.node,
  bottomPoints: PropTypes.array.isRequired,
  transferPoints: PropTypes.array,
  isExpandButtonShown: PropTypes.bool,
  isExpanded: PropTypes.bool,
  isCollapseButtonShown: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  hiddenPointsCount: PropTypes.number.isRequired,
  isToggleHidden: PropTypes.bool,
  isPreviewDetails: PropTypes.bool
};